export default "__VITE_ASSET__B4K9H7Wk__"